/* unplugin-vue-components disabled */import { render } from "./robotIcon.vue?vue&type=template&id=702c0f29"
import script from "./robotIcon.vue?vue&type=script&lang=js"
export * from "./robotIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__